<template>
    <div class="block-editor holiday-plus-hotels">
        <div class="editor-row">
            <div class="editor-row-title">Adult Count</div>
            <TiptapEditor
                placeholder="Adult Count"
                :show-attributes="true"
                :max-character-count="500"
                v-model="clone.adultCount"
            />
        </div>
        <div class="editor-row">
            <div class="editor-row-title">Child Count</div>
            <TiptapEditor
                placeholder="Child Count"
                :show-attributes="true"
                :max-character-count="500"
                v-model="clone.childCount"
            />
        </div>
        <div class="editor-row">
            <div class="editor-row-title">Check In</div>
            <TiptapEditor
                placeholder="Check In"
                :show-attributes="true"
                :max-character-count="500"
                v-model="clone.checkIn"
            />
        </div>
        <div class="editor-row">
            <div class="editor-row-title">Check Out</div>
            <TiptapEditor
                placeholder="Check Out"
                :show-attributes="true"
                :max-character-count="500"
                v-model="clone.checkOut"
            />
        </div>
        <div class="editor-row">
            <div class="editor-row-title">Children's Ages</div>
            <TiptapEditor
                placeholder="Child Birthdays"
                :show-attributes="true"
                :max-character-count="500"
                v-model="clone.childrenAges"
            />
        </div>
        <div class="inputTitle mt-1 mb-2 font-weight-bold">{{ $t("chatbotv2.followingAttributesFilled") }}</div>
        <section class="next-step-filled-items-wrapper">
            <div class="logos middle-section" v-for="attr in nextStepFilledValue" :key="attr">
                <AttributeIconPreview :attribute="attr" />
                <span class="ml-2">
                    <AttributeLabel :attribute="attr" />
                </span>
            </div>
        </section>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";
import AttributePicker from "../pickers/AttributePicker.vue";
import AttributeIconPreview from "../common/AttributeIconPreview.vue";
import AttributeLabel from "../common/tiptap-extensions/AttributeLabel.vue";

const log = log2("HolidayPlusHotels");
export default {
    name: "HolidayPlusHotels",
    components: { AttributeLabel, AttributeIconPreview, AttributePicker, TiptapEditor },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
            nextStepFilledValue: [
                "holiday_plus_selected_hotel_id",
                "holiday_plus_checkin",
                "holiday_plus_checkout",
                "holiday_plus_child_count",
                "holiday_plus_adult_count",
                "holiday_plus_child_dates",
            ],
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.holiday-plus-hotels {
    padding: 20px;
    display: flex;
    gap: 20px;
    flex-direction: column;

    .editor-row {
        width: 100%;

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
            display: flex;
            align-items: center;
            gap: 5px;
        }
    }

    .next-step-filled-items-wrapper {
        background: #fff;
        border-radius: 6px;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 20px;
        padding: 20px;
        width: 100%;

        .middle-section {
            background: #ffdc66;
            cursor: pointer;
            transition: all 0.3s;
            border-radius: 10px;
            box-decoration-break: clone;
            display: flex;
            justify-content: center;
            padding: 5px;
            width: fit-content;
            margin: 5px;
            align-items: center;
            font-weight: 800;
        }
    }
}
</style>
